.tile {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 16px 18px;
  min-width: 0;

  .top {
    display: flex;
    align-items: center;
    gap: 10px;
    color: var(--vc-text-secondary);
    font-size: var(--vc-text-sm);
    font-weight: var(--vc-weight-medium);
  }

  .icon {
    width: 28px;
    height: 28px;
    border-radius: 8px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    background: var(--kpi-bg, var(--vc-gray-soft));
    color: var(--kpi-fg, var(--vc-text-secondary));
    flex: none;

    svg {
      width: 15px;
      height: 15px;
    }
  }

  .bottom {
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    gap: 12px;
  }

  .value {
    font-size: var(--vc-text-2xl);
    font-weight: var(--vc-weight-bold);
    letter-spacing: -0.02em;
    line-height: 1;
  }

  .unit {
    font-size: var(--vc-text-sm);
    font-weight: var(--vc-weight-medium);
    color: var(--vc-text-muted);
    margin-left: 4px;
  }

  .delta {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    font-size: var(--vc-text-xs);
    color: var(--vc-text-muted);
    margin-top: 8px;
  }

  .deltaPill {
    display: inline-flex;
    align-items: center;
    gap: 2px;
    padding: 2px 6px;
    border-radius: var(--vc-radius-pill);
    font-weight: var(--vc-weight-semibold);

    &.up {
      background: var(--vc-green-soft);
      color: var(--vc-green);
    }

    &.down {
      background: var(--vc-red-soft);
      color: var(--vc-red);
    }
  }

  .spark {
    width: 84px;
    height: 32px;
    flex: none;
  }

  &.blue {
    --kpi-bg: var(--vc-blue-soft);
    --kpi-fg: var(--vc-blue);
  }
  &.amber {
    --kpi-bg: var(--vc-amber-soft);
    --kpi-fg: var(--vc-amber);
  }
  &.red {
    --kpi-bg: var(--vc-red-soft);
    --kpi-fg: var(--vc-red);
  }
  &.green {
    --kpi-bg: var(--vc-green-soft);
    --kpi-fg: var(--vc-green);
  }
  &.purple {
    --kpi-bg: var(--vc-purple-soft);
    --kpi-fg: var(--vc-purple);
  }
  &.teal {
    --kpi-bg: var(--vc-teal-soft);
    --kpi-fg: var(--vc-teal);
  }
  &.gray {
    --kpi-bg: var(--vc-gray-soft);
    --kpi-fg: var(--vc-text-secondary);
  }
}

.grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));
  gap: 16px;
}
